/* eslint-disable react/no-array-index-key */
import { useMemo } from 'react';
import classNames from 'classnames';
import { useStrapiGlobal } from '@/context';
import { Link } from 'react-router-dom';

type FooterTopProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-footer__middle';

export const FooterMiddle = ({ className }: FooterTopProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const { layout, socialMedia, menu } = useStrapiGlobal();
	const { footer } = layout;
	const { middle } = footer;
	const { address, map, legalText } = middle;
	const { navItems } = menu;
	return (
		<section className={wrapperClassName}>
			<div className="o-container">
				<div className={`${classNameComponent}-content`}>
					<div className={`${classNameComponent}-row`}>
						{/* Col 1: Contacto */}
						<div className={`${classNameComponent}-col`}>
							<h4 className={`${classNameComponent}-title`}>Contacto</h4>
							<address className={`${classNameComponent}-address`}>
								{address.items.map((item, i) => (
									<span key={i} className={`${classNameComponent}-address-line`}>
										{item.text}
									</span>
								))}
							</address>
						</div>

						{/* Col 2: Mapa */}
						<div className={`${classNameComponent}-col ${classNameComponent}-map`}>
							<iframe
								src={map}
								title="Ubicación en mapa"
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
								sandbox="allow-scripts"
							/>
						</div>

						{/* Col 3: Menú */}
						<div className={`${classNameComponent}-col ${classNameComponent}-menu`}>
							<h4 className={`${classNameComponent}-title`}>Menú</h4>
							<ul className={`${classNameComponent}-list ${classNameComponent}-list--columns`}>
								{navItems.map((it: { name: string }) => (
									<li key={it.name} className={`${classNameComponent}-list-item`}>
										<span>{it.name}</span>
									</li>
								))}
							</ul>
						</div>

						{/* Col 4: Redes */}
						<div className={`${classNameComponent}-col ${classNameComponent}-social`}>
							<ul className={`${classNameComponent}-social-list`}>
								{socialMedia.map((item) => (
									<li key={item.id}>
										<Link to={item.url} aria-label={item.socialNetwork}>
											<img src={item.icon.url} alt="" aria-hidden="true" />
										</Link>
									</li>
								))}
							</ul>
						</div>
					</div>

					<div className={`${classNameComponent}-row ${classNameComponent}-row--one-col`}>
						<p className={`${classNameComponent}-legalText`}>{legalText}</p>
					</div>
				</div>
			</div>
		</section>
	);
};
